import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ALL_TAG } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AllListTagDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadListTag =
  (): ThunkAction<Promise<void>, State, null, AllListTagDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: ALL_TAG + REQUEST });
    try {
      const payload = await api.loadAllTag();
      dispatch({ type: ALL_TAG + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ALL_TAG + FAILURE, error });
    }
  };

export const allListTagIdle = () => ({ type: ALL_TAG + IDLE });
